export default __webpack_public_path__ + "static/media/powerlogo.bd339855.svg";